import React from 'react'
import { CreateChannelButton } from './CreateChannelButton'
import { SectionHeader } from './index'

export const ALL_CHANNELS_SECTION_ID = `all-channels-section`

export type AllChannelsSectionHeaderProps = {
  channelsCount: number
  isExpanded: boolean
  onToggleExpand: (sectionId: string) => void
}

export const AllChannelsSectionHeader = ({
  channelsCount,
  isExpanded,
  onToggleExpand,
}: AllChannelsSectionHeaderProps) => (
  <SectionHeader
    className="margin-top-medium"
    sectionId={ALL_CHANNELS_SECTION_ID}
    label={
      <>
        <span className="font-weight-bold">All channels</span>{' '}
        {isExpanded ? null : (
          <span className="margin-left-smaller shade-20 font-weight-medium">
            ({channelsCount} hidden)
          </span>
        )}
      </>
    }
    rightPart={<CreateChannelButton />}
    onToggleExpand={onToggleExpand}
    isExpanded={isExpanded}
  />
)
